import React from "react";
import { motion } from "framer-motion";
import ProfileDropdown from "../LandingPage/ProfileDropdown";
import RegisterButton from "../Auth/RegisterButton";
import LoginButton from "../Auth/LoginButton";

const NavbarDesktop = ({ 
  navItems, 
  activeSection, 
  handleScrollTo, 
  isLoggedIn, 
  imgSrc, // Ini yang tadi menyebabkan error karena belum terpasang
  userName, 
  handleLogout, 
  renderLogo 
}) => {
  return (
    <div className="hidden xl:flex absolute top-0 left-0 w-full h-32 items-center">
      <div className="absolute inset-0 bg-white/80 dark:bg-slate-950/90 backdrop-blur-xl border-b border-slate-100 shadow-sm" />   
      <div className="max-w-full mx-auto px-10 relative w-full flex items-center justify-between">           
        
        {/* Logo Section */}
        <div className="flex-1 flex justify-start">{renderLogo()}</div>

        {/* Navigation Items */}
        <div className="flex-none flex gap-8 h-20 items-center justify-center mx-8">
          {navItems.map((item) => (
            <button
              key={item.id}
              onClick={() => handleScrollTo(item.id)}
              className={`relative text-xs font-black uppercase tracking-[0.1em] transition-all h-full flex items-center ${
                activeSection === item.id ? "text-blue-600" : "text-slate-600 hover:text-blue-600"
              }`}
            >
              {item.name}
              {activeSection === item.id && (
                <motion.div 
                  layoutId="navbar-underline" 
                  className="absolute bottom-0 left-0 right-0 h-[3px] bg-[#044A8C]" 
                  transition={{ type: "spring", stiffness: 380, damping: 30 }} 
                />
              )}
            </button>
          ))}
        </div>

        {/* Auth Section */}
        <div className="flex-1 flex items-center gap-3 justify-end">
          {isLoggedIn ? (
            <ProfileDropdown 
              imgUrl={imgSrc} 
              userName={userName} 
              handleLogout={handleLogout} 
            />
          ) : (
            <>
              <RegisterButton />
              <LoginButton />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default NavbarDesktop;